'use strict';

export default class LoginController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;


  /*@ngInject*/
  constructor(Auth, $state, $analytics, $cookieStore, $location) {
    this.Auth = Auth;
    this.$state = $state;
    this.$analytics = $analytics;
    this.$cookieStore = $cookieStore;
    this.$location = $location;
  }

  login(form) {
    this.submitted = true;

    if(form.$valid) {
      this.Auth.login({
        email: this.user.email,
        password: this.user.password
      })
        .then(() => {
          if (this.$analytics) {
            this.$analytics.setUsername(this.user.email);
          }

          if (typeof this.$cookieStore.get('returnUrl') != 'undefined' && this.$cookieStore.get('returnUrl') != '')
          {
            this.$location.path(this.$cookieStore.get('returnUrl'));
            this.$cookieStore.remove('returnUrl');
          }
          else
          {
            // Logged in default if no returnUrl defined: redirect to home
            this.$state.go('home');
          }
        })
        .catch(err => {
          this.errors.login = err.message;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.js